import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, MonthRangeValue} from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class MonthRangeHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const arr = [];
    const mrv = (qc.value as MonthRangeValue);
    mrv.startTime && arr.push({
      'FilterField': qc.fieldCode,
      'Compare': CompareType.GreaterOrEqual, // GreaterOrEqual
      'Value': mrv.startTime,
      'Relation': RelationType.And, // and
      'Expresstype': ValueType.Value
    });
    mrv.endTime && arr.push({
      'FilterField': qc.fieldCode,
      'Compare': CompareType.LessOrEqual, // LessOrEqual
      'Value': mrv.endTime,
      'Relation': RelationType.And, // and
      'Expresstype': ValueType.Value
    });

    return arr;
  }
}
